import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { finalize, Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  standalone: false,
  templateUrl: './reset-password.html',
  styleUrls: ['./reset-password.scss'],
})
export class ResetPassword implements OnDestroy {
  form: FormGroup;
  loading = false;

  passwordTextType = false;
  confPasswordTextType = false;
  declare feather: any;

  token = '';
  private _unsubscribeAll = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private _authServ: AuthService,
    private _toastrServ: ToastrService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {
    this.form = this.fb.nonNullable.group(
      {
        password: ['', Validators.required],
        confPassword: ['', Validators.required],
      },
      { validators: this.confirmPasswordValidator }
    );

    this._route.queryParams
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((params) => {
        this.token = params?.['token'] || '';
      });
  }

  get password() {
    return this.form.get('password');
  }

  get confPassword() {
    return this.form.get('confPassword');
  }

  confirmPasswordValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password')?.value;
    const confirm = control.get('confPassword')?.value;

    if (password && confirm && password !== confirm) {
      return { passwordMismatch: true };
    }
    return null;
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
    setTimeout(() => this.feather.replace());
  }

  toggleConfPasswordTextType() {
    this.confPasswordTextType = !this.confPasswordTextType;
    setTimeout(() => this.feather.replace());
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.invalid || !this.token) return;
    console.log('🚀 ~ ResetPassword ~ onSubmit ~ this.token:', this.token);

    this.loading = true;

    this._authServ
      .reset({
        token: this.token,
        newPassword: this.form.value.password!,
      })
      .pipe(
        takeUntil(this._unsubscribeAll),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: () => {
          this._toastrServ.success('Password reset successful.');
          this._router.navigateByUrl('/app/auth/login');
        },
        error: (err) => {
          this._toastrServ.error(err?.error?.message || 'Reset failed');
        },
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
